import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-api-contract',
  templateUrl: './api-contract.component.html',
  styleUrls: ['./api-contract.component.scss'],
})
export class ApiContractComponent implements OnInit {
  constructor(
    public commonService: CommonService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.getAPIData();
  }

  selected_api_filter: any = 'All';
  api_data: any = [];
  api_data_loaded: boolean = false;
  getAPIData() {
    this.api_data_loaded = false;

    this.selected_api_group = {
      id: '',
    };
    this.selected_api = {
      id: '',
    };

    let route: any = '/apidetails/';
    if (this.selected_api_filter != 'All') {
      route = route + '?type=' + this.selected_api_filter;
    }

    this.commonService.getData(route).subscribe(
      (res: any) => {
        this.api_data = res;
        this.api_data_loaded = true;
        if (this.api_data.length > 0) {
          this.selectAPIGroup(this.api_data[0]);
        }
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  selected_api_group: any = {
    id: '',
  };
  selectAPIGroup(group) {
    this.selected_api_group = group;
    this.selected_api = {
      id: '',
    };
    setTimeout(() => {
      const element = document.getElementById(this.selected_api_group.id);
      this.scroll(element);
    }, 200);
  }

  selected_api: any = {
    id: '',
  };
  api_expanded_id: any = '';
  selectAPI(group, api, event) {
    this.selected_api_group = group;
    this.selected_api = api;
    event.stopPropagation();
    setTimeout(() => {
      const element = document.getElementById(this.selected_api.id);
      this.scroll(element);
    }, 200);
  }

  scroll(el: HTMLElement) {
    // el.scrollIntoView({behavior: 'smooth',});

    const container = document.getElementById('api-contract-container');

    // Calculate the position you want to scroll to with the offset
    const rect = el.getBoundingClientRect();
    const containerTop = container.getBoundingClientRect().top;
    const offset = 50; // Define your offset value
    const finalPosition =
      rect.top - containerTop + container.scrollTop - offset;

    // Smoothly scroll to the calculated position
    container.scrollTo({
      top: finalPosition,
      behavior: 'smooth',
    });
  }

  getHTML(html) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

  toggleAPISelection(value) {
    if (this.api_expanded_id == value) {
      this.api_expanded_id = '';
    } else {
      this.api_expanded_id = value;
    }
  }
}
